/**
 * @fileoverview Barrel exports for the chapter-planner-composite-v1 COMPOSITE agent.
 *
 * This composite orchestrates:
 * - chapter-planner-v2 (sequential, generates chapter skeleton with key-events seed)
 * - key-events-expander-v2 (sequential, develops seed into full beat sheet)
 *
 * Structure:
 * - definition.ts: Agent metadata with composite configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Placeholder prompt (primitives have their own prompts)
 * - flow.ts: Orchestration logic (planner → expander)
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow } from './flow';

